import { FC } from 'react'
import clsx from 'clsx'
import PdMedia from '@/components/pd-media/pd-media'
import TitleAndDesc from '@/components/standard/title-and-desc'

type Section7Type = {
  title: string
  desc: string
  mediaUrl: string
  theme?: string
}

const Section7: FC<Section7Type> = ({ title, desc, mediaUrl = '', theme }) => {
  return (
    <div className={clsx('w-full h-fit', 'py-15 laptop:py-30', `pd-theme-${theme}`, 'bg-anti-blk')}>
      <TitleAndDesc title={title} desc={desc} titleTag="h2" />
      <div className={clsx('w-full max-w-300 mx-auto', 'px-6 laptop:px-0')}>
        <div className={clsx('w-full')} style={{ aspectRatio: '2/1' }}>
          <PdMedia src={mediaUrl} mask={false} />
        </div>
      </div>
    </div>
  )
}

export default Section7
